export enum VerificationStatus {
	VERIFICATION_STATE_UNSPECIFIED = 'VERIFICATION_STATE_UNSPECIFIED',
	VERIFICATION_STATE_UNVERIFIED = 'VERIFICATION_STATE_UNVERIFIED',
	VERIFICATION_STATE_PENDING = 'VERIFICATION_STATE_PENDING',
	VERIFICATION_STATE_VERIFIED = 'VERIFICATION_STATE_VERIFIED',
	VERIFICATION_STATE_SUSPENDED_IN_GMB = 'VERIFICATION_STATE_SUSPENDED_IN_GMB'
}
